import ComingSoon from "@/components/ComingSoon";

export default function PreferencesPage() {
  return <ComingSoon featureName="Preferences" description="User preferences, profile management, and custom avatars. This feature requires backend Preferences/Avatar APIs." />;
}
